import { Pipe, PipeTransform } from '@angular/core';
import sumBy from 'lodash-es/sumBy';

import { PassengerArrangement, PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { Room } from '@shared/base-search-bar/entities/room.entities';
import { PASSENGER_CHILDREN_RANGE_AGES } from '@booking/constants/forms.constants';

@Pipe({
  name: 'guestToPassengerUI',
  standalone: false
})
export class GuestToPassengerUIPipe implements PipeTransform {

  transform(rooms: Room[]): PassengerArrangement[] {
    const adults = sumBy(rooms, PassengerType.ADULTS);
    const allAges = [].concat(...rooms.map(room => room.childrenAges));
    const childrens = allAges.filter(age => age >= PASSENGER_CHILDREN_RANGE_AGES.MIN).length;
    const infants = allAges.filter(age => age < PASSENGER_CHILDREN_RANGE_AGES.MIN).length;
    return [{
      id: PassengerType.ADULTS,
      quantity: adults
    }, {
      id: PassengerType.CHILDREN,
      quantity: childrens
    }, {
      id: PassengerType.INFANTS,
      quantity: infants
    }];
  }
}
